import React from 'react';
import { TouchableOpacity, StyleSheet, Text } from 'react-native';
import theme from '../../../common/theme';

const styles = StyleSheet.create({
  defaultStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.pink,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginRight: 8,
  },
  textStyle: {
    color: theme.colors.white,
    fontSize: theme.radius.large,
  },
});
const Badge: React.FC = () => {
  return (
    <TouchableOpacity style={styles.defaultStyle}>
      <Text style={styles.textStyle}>{'CDS'}</Text>
    </TouchableOpacity>
  );
};

export default Badge;
